import { StyleSheet } from "react-native";
export const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
    },
    inputsContainer: {
        flexDirection: "row",
        flex: 1,
        justifyContent: "space-between",
    },
    codeContainer: {
        borderWidth: 1,
        borderRadius: 12,
        borderColor: "#DFDFDE",
        height: 60,
        width: 44,
        justifyContent: "center",
        alignItems: "center",
    },
    codeText: {
        fontSize: 28,
        lineHeight: 38,
        color: '#1D2939'
    },
    hiddenInput: {
        width: 0.1,
        height: 0.1,
        color: 'white',
        backgroundColor: 'transparent',
        opacity: 0.1,
        zIndex: 1,
        fontSize: 20,
        caretColor: 'transparent',
        userSelect: 'none',
        outline: 'none',
        appearance: 'none',
        borderColor: 'red',
        position: 'absolute', top: 0, left: 0
    },
    hiddenInputAndroid: {
        width: 50,
        height: 50,
        color: 'white',
        backgroundColor: 'transparent',
        opacity: 0.1,
        zIndex: 2,
        fontSize: 20,
        caretColor: 'transparent',
        userSelect: 'none',
        outline: 'none',
        appearance: 'none',
        borderColor: 'red',
        position: 'absolute', top: 0, left: 0
    },
    stick: {
        width: 2,
        height: 30,
        backgroundColor: "green",
    },
    otpBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
